import { type FC, type ReactNode, type UIEventHandler } from 'react'
import { observer } from 'mobx-react-lite'
import { Scrollbar, SpinnerLoader } from 'shared/ui'
import { type CallContact } from 'entities/Call/model/CallContact'
import { ContactCard } from './ContactCard'
import styles from './styles.module.scss'

type IContactsListProps = {
  items: CallContact[]
  handleScroll?: UIEventHandler
  loading?: boolean
  ariaLabel?: string
  autoHeightMax?: number
  renderBottom?: (item: CallContact) => ReactNode
  renderActions?: (item: CallContact) => ReactNode
  alwaysShowActions?: boolean
  onItemClick?: (item: CallContact) => void
}

export const ContactsList: FC<IContactsListProps> = observer(
  ({
    items,
    handleScroll,
    loading,
    ariaLabel = 'ContactsList',
    autoHeightMax = 258,
    renderBottom,
    renderActions,
    alwaysShowActions,
    onItemClick,
  }) => {
    return (
      <Scrollbar autoHeight autoHeightMin={0} autoHeightMax={autoHeightMax} onScroll={handleScroll}>
        <div className={styles.list}>
          {items.map((item) => (
            <ContactCard
              key={item.sid || item.id}
              item={item}
              onClick={onItemClick}
              bottomSlot={renderBottom?.(item)}
              actionsSlot={renderActions?.(item)}
              alwaysShowActions={alwaysShowActions}
            />
          ))}
          {loading && (
            <div className={styles.loader}>
              <SpinnerLoader ariaLabel={ariaLabel} size={16} />
            </div>
          )}
        </div>
      </Scrollbar>
    )
  }
)
